// user constants
export const LOG_IN_SUCCESS = "LOG_IN_SUCCESS";
export const LOG_IN_START = "LOG_IN_START";
export const LOG_IN_FAIL = "LOG_IN_FAIL";
export const SIGN_UP_START = "SIGN_UP_START";
export const SIGN_UP_FAIL = "SIGN_UP_FAIL";
export const LOG_OFF = "LOG_OFF";
export const REMOVE_AUTH_ERROR = "REMOVE_AUTH_ERROR";
export const REQUEST_AUTH = "REQUEST_AUTH";
export const UNREQUEST_AUTH = "UNREQUEST_AUTH";

// content constants
export const GET_EVENTS_START = "GET_EVENTS_START";
export const GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS";
export const GET_EVENTS_FAIL = "GET_EVENTS_FAIL";

export const GET_NEWSLETTERS_START = "GET_NEWSLETTERS_START";
export const GET_NEWSLETTERS_SUCCESS = "GET_NEWSLETTERS_SUCCESS";
export const GET_NEWSLETTERS_FAIL = "GET_NEWSLETTERS_FAIL";

export const REMOVE_CONTENT_ERROR = "REMOVE_CONTENT_ERROR";
